import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useSiteContent } from "./siteContent";

const MaskedLine = ({ children, delay }) => (
  <span className="block overflow-hidden pb-1">
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export default function Hero({ onReservar, onEncomendar, onVerPratos }) {
  const site = useSiteContent();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);

  return (
    <section
      id="inicio"
      ref={ref}
      data-testid="hero-section"
      className="relative flex min-h-screen items-end overflow-hidden"
    >
      <motion.div style={{ y: imgY }} className="absolute inset-0">
        <motion.img
          data-testid="hero-image"
          src={site.hero_image}
          alt="Salle du restaurant"
          initial={{ scale: 1.18 }}
          animate={{ scale: 1 }}
          transition={{ duration: 7, ease: "easeOut" }}
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-black/30" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-5 pb-16 pt-40 md:px-10 md:pb-24">
        <h1
          data-testid="hero-title"
          className="font-display text-4xl italic leading-[1.02] tracking-tight text-[#F4F1EB] sm:text-5xl lg:text-6xl"
        >
          <MaskedLine delay={0.45}>{site.hero_line1}</MaskedLine>
          <MaskedLine delay={0.6}>{site.hero_line2}</MaskedLine>
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.1 }}
          className="mt-6 max-w-md text-sm text-[#F4F1EB]/85 md:text-base"
        >
          {site.hero_text}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.3 }}
          className="mt-8 flex flex-wrap gap-3"
        >
          <button
            data-testid="hero-reservar-btn"
            onClick={onReservar}
            className="rounded-full bg-[#F4F1EB] px-7 py-3 text-xs uppercase tracking-[0.2em] text-[#102C1F] transition-colors duration-300 hover:bg-[#E5DFD3]"
          >
            {site.hero_btn_reserve}
          </button>
          <button
            data-testid="hero-encomendar-btn"
            onClick={onEncomendar}
            className="rounded-full bg-[#F4F1EB] px-7 py-3 text-xs uppercase tracking-[0.2em] text-[#102C1F] transition-colors duration-300 hover:bg-[#E5DFD3]"
          >
            {site.hero_btn_order}
          </button>
          <button
            data-testid="hero-ver-pratos-btn"
            onClick={onVerPratos}
            className="rounded-full border border-[#F4F1EB]/60 px-7 py-3 text-xs uppercase tracking-[0.2em] text-[#F4F1EB] transition-colors duration-300 hover:border-[#F4F1EB] hover:bg-[#F4F1EB]/10"
          >
            {site.hero_btn_dishes}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
